import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, TableCell, styled } from '@mui/material';
import { DeleteIcon, EditIcon, ExtendedMenuIcon } from '@synergy/theme-next';
import { DuplicateIcon } from '@synergy/theme';
import { FormattedMessage } from 'react-intl';
import { MouseEvent, useState } from 'react';
import { PoolTypography } from '@synergy/components-next';
import { converter } from '@synergy/utils';

import { InvoiceTextItem } from '../../../../models/invoice-text-item';
import { PositionSelection, PositionSelectionBox } from '../../../../../../common/components/palo/position-selection';
import { ROW_HANDLE_SX, RowDrag, rowDragHandleProps } from '../../../../../../common/components/palo/position-row-drag';
import { RowPosition } from './detail-positions-table';

export interface DetailPositionsTableTextItemRowProps {
    index: number;
    item: InvoiceTextItem;
    readonly: boolean;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(1),
}));

export const DetailPositionsTableTextItemRow = (props: DetailPositionsTableTextItemRowProps) => {
    const { readonly, index, item } = props;
    const [menuRef, setMenuRef] = useState<null | HTMLElement>(null);
    const isMenuOpen = Boolean(menuRef);

    const handleMenuClick = (event: MouseEvent<HTMLButtonElement>): void => {
        setMenuRef(event.currentTarget);
    };
    const handleMenuClose = (): void => {
        setMenuRef(null);
    };

    return (
        <>
            <StyledTableCell colSpan={7}>
                <PoolTypography typography="body2">{item.title}</PoolTypography>
                <PoolTypography typography="label">
                    <Box
                        color="grey[800]"
                        dangerouslySetInnerHTML={{
                            __html: converter.makeHtml(item.description ?? ''),
                        }}
                        sx={{ '& p': { margin: 0 } }}
                    />
                </PoolTypography>
            </StyledTableCell>
        </>
    );
};
